import { render, staticRenderFns } from "./order-refund-page.vue?vue&type=template&id=3dab0407&scoped=true"
import script from "./order-refund-page.vue?vue&type=script&lang=js"
export * from "./order-refund-page.vue?vue&type=script&lang=js"
import style0 from "./order-refund-page.vue?vue&type=style&index=0&id=3dab0407&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dab0407",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/快电商/preview-qcommerce-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dab0407')) {
      api.createRecord('3dab0407', component.options)
    } else {
      api.reload('3dab0407', component.options)
    }
    module.hot.accept("./order-refund-page.vue?vue&type=template&id=3dab0407&scoped=true", function () {
      api.rerender('3dab0407', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/h5/order-refund-page.vue"
export default component.exports